class FooterVaillantAccordion {
  constructor(root) {
    this.root = root;
    this.columns = [...root.querySelectorAll('[data-footer-menu-col].footer-vaillant__menu-col--accordion')];
    this.desktopQuery = window.matchMedia('(min-width: 750px)');

    if (!this.columns.length) return;

    this.bindEvents();
    this.lockColumnWidths();
    window.addEventListener('resize', this.lockColumnWidths.bind(this), { passive: true });
    this.desktopQuery.addEventListener('change', this.lockColumnWidths.bind(this));
    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.lockColumnWidths());
    }
  }

  lockColumnWidths() {
    if (!this.desktopQuery.matches) return;

    this.columns.forEach((column) => {
      column.style.width = '';
      column.style.maxWidth = '';

      const trigger = column.querySelector('[data-footer-menu-trigger]');
      const linksList = column.querySelector('.footer-vaillant__menu-links');
      const links = [...column.querySelectorAll('.footer-vaillant__menu-link')];
      if (!trigger) return;

      let maxWidth = Math.ceil(trigger.getBoundingClientRect().width);

      if (linksList && links.length) {
        linksList.style.display = 'flex';
        linksList.style.visibility = 'hidden';
        linksList.style.position = 'absolute';

        links.forEach((link) => {
          maxWidth = Math.max(maxWidth, Math.ceil(link.getBoundingClientRect().width));
        });

        linksList.style.display = '';
        linksList.style.visibility = '';
        linksList.style.position = '';
      }

      column.style.width = `${maxWidth}px`;
      column.style.maxWidth = `${maxWidth}px`;
    });
  }

  bindEvents() {
    this.columns.forEach((column) => {
      const trigger = column.querySelector('[data-footer-menu-trigger]');
      if (!trigger) return;

      trigger.addEventListener('click', () => this.toggleAll(column));
    });
  }

  toggleAll(clickedColumn) {
    const shouldOpen = !clickedColumn.classList.contains('is-open');

    this.columns.forEach((column) => {
      const trigger = column.querySelector('[data-footer-menu-trigger]');
      if (!trigger) return;

      column.classList.toggle('is-open', shouldOpen);
      trigger.setAttribute('aria-expanded', shouldOpen ? 'true' : 'false');
    });
  }
}

class FooterVaillantInputScrollGuard {
  constructor(root) {
    this.scrollY = 0;
    this.activeInput = null;
    this.onViewportChange = this.onViewportChange.bind(this);

    root.querySelectorAll('#FooterVaillantNewsletterEmail, .country-filter__input').forEach((input) => {
      input.addEventListener('focus', () => this.start(input));
      input.addEventListener('blur', () => this.stop(input));
    });
  }

  start(input) {
    if (this.activeInput) return;

    this.activeInput = input;
    this.scrollY = window.scrollY;
    this.restoreScroll();
    requestAnimationFrame(() => this.restoreScroll());
    setTimeout(() => this.restoreScroll(), 0);
    setTimeout(() => this.restoreScroll(), 100);

    window.visualViewport?.addEventListener('resize', this.onViewportChange);
    window.visualViewport?.addEventListener('scroll', this.onViewportChange);
  }

  stop(input) {
    if (this.activeInput !== input) return;

    window.visualViewport?.removeEventListener('resize', this.onViewportChange);
    window.visualViewport?.removeEventListener('scroll', this.onViewportChange);
    this.activeInput = null;
  }

  onViewportChange() {
    this.restoreScroll();
  }

  restoreScroll() {
    window.scrollTo(0, this.scrollY);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-footer-vaillant]').forEach((footer) => {
    new FooterVaillantAccordion(footer);
    new FooterVaillantInputScrollGuard(footer);
  });
});
